import { render, staticRenderFns } from "./pCenter.vue?vue&type=template&id=52ec508a&scoped=true"
import script from "./pCenter.vue?vue&type=script&lang=js"
export * from "./pCenter.vue?vue&type=script&lang=js"
import style0 from "./pCenter.vue?vue&type=style&index=0&id=52ec508a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ec508a",
  null
  
)

export default component.exports